import React, { Component } from 'react'
import Styles from '../../Css/Hotspot/Hotspot.module.css'
import {connect} from 'react-redux'
import {typeOfHotspot} from './HotSpotConfig'
import {Toast} from 'react-bootstrap'
import HotSpotDeleteModal from './HotSpotDeleteModal';
import 'animate.css';
import HotSpotChildComponentLoading from './HotSpotChildComponentLoading'
//redux
import {
    updateHotspot,
    addHotspot,
    deleteHotspot,
    updateCurrentHotSpotId,
    updateCurrentHotSpotObj,
    updateWholeHotSpotMapObj,
    upateSyncHotSpotTitleDescURL,
    updateWholeSyncHotSpotTitleDescURL
} from '../../Redux/Reducers/HotspotEditReducer/HotspotEditActionController'
import alertify from 'alertifyjs'
import centralAPI from '../../CentralAPIHandler/CentralAPIHandler'
class HotSpotAddDetails extends Component {

    constructor(props){
        super(props);

        this.state = {
            typeOfHotspot : {
                type: '', imgSrc: ''
            },
            //renderChild: true,
            hotSpotObj: new Map(),

            showDelete : {
                showDeleteWarningPopUp: false,
                hotSpotIdToDelete: '',
                hotSpotTitleToDelete: ''
            },

            infoToast : {
                show: false,
            },

            imageDeletionLoading: false
        }

        this.typeOfHotspotCurrentRef = React.createRef()
    }

    componentDidMount(){

        this.setHotSpotObjInState();

        // assign checkRemovalOfLiRef, value of checkRemovalOfLi()
        this.props.setCheckRemovalOfLiRef(this.checkRemovalOfLi);
    }

    setHotSpotObjInState = ()=>{
        try {
            if(this.props.hotSpotMapObj && this.props.hotSpotMapObj.size > 0 ){
                // loop thru all keys and within them thru all hotspots and add it to hotSpotObj state

                const newStateHotSpotObj = new Map();

                let allImageKeys = [...this.props.hotSpotMapObj.keys()];

                allImageKeys.forEach(key=>{
                    // each imageObj contains imageHotSpots Map , which contains actual hotSpots

                    // now if this hotSpotId is not registered in state's hotSpotObj, add it, else ignore it

                    if(this.props.hotSpotMapObj.get(key).imageHotSpots && this.props.hotSpotMapObj.get(key).imageHotSpots.size>0){
                        const hotSpotIDs = [...this.props.hotSpotMapObj.get(key).imageHotSpots.keys()];

                        // loop thru the images and add the key plus obj to state hotSpotObj

                        hotSpotIDs.forEach(hotSpotId=>{
                            if(!this.state.hotSpotObj.has(hotSpotId)){
                                const hotSpotObj = this.props.hotSpotMapObj.get(key).imageHotSpots.get(hotSpotId);

                                // delete _id prop
                                delete hotSpotObj._id;

                                newStateHotSpotObj.set(hotSpotId, hotSpotObj);
                            }
                        });
                    }


                });

                //console.log('newStateHotSpotObj',newStateHotSpotObj);
                this.setState({
                    ...this.state,
                    hotSpotObj : newStateHotSpotObj
                })
            }
        } catch (error) {
            //console.log(error);
        }
    }

    handleCreateHotspot = (e) => {

        try {

            //console.log('this.state.typeOfHotspot',this.state.typeOfHotspot);
            let hotSpotJSON = {
                imageId: `${this.props.currentImgObj.image_id}`,
                hotSpotId: `${this.props.currentImgObj.image_id}_${Date.now()}`, //skuId_imgId_seqNo,
                isHidden: false,
                hotSpotIconSrc: `${this.state.typeOfHotspot.imgSrc ? this.state.typeOfHotspot.imgSrc : typeOfHotspot[0].imgSrc}`,
                coordinates: {
                    xAxis: 50, // in percent (during run time, convert it to pixel)
                    yAxis:  50// in percent (during run time, convert it to pixel)
                },
                timeStamp: {
                    createdOn:Date.now(),
                    updatedOn:Date.now()
                },
                hotSpotDesc:'',
                hotSpotURL: '',
                hotSpotTitle:'',
                hotSpotCloseUpURL: ''
            }

            // update image hotspot mapping
            this.props.addHotspot(hotSpotJSON, this.props.currentImgObj.image_id);   
            
            // update hotspotTitle obj in state
            let newMap = new Map(this.state.hotSpotObj);
            newMap.set(hotSpotJSON.hotSpotId, hotSpotJSON);
            this.setState({
                ...this.state,
                hotSpotObj: newMap,
                infoToast: {
                    show: true
                }
            });
            
            // add hotspot id as well as currenthotspotobj to store
            
            this.props.updateCurrentHotSpotId(hotSpotJSON.hotSpotId);
            this.props.updateCurrentHotSpotObj(hotSpotJSON);
            
        } catch (e) {
            alertify.error('Unknown Error Occurred')
            //console.log(e);

        }

    }

    handleTypeOfHotspot = (e, typeOfHotspot)=>{
        if(!typeOfHotspot) return;

        this.setState({
            ...this.state,
            typeOfHotspot: typeOfHotspot
        });
        let span = this.typeOfHotspotCurrentRef.current;
        // change src of this img
        span.children[0].setAttribute('src', typeOfHotspot.imgSrc);
    }


    /**
     * Handle deletion of all hotspotIds from all images
     * @param {*} e 
     */
    handleAllHotSpotDeletion = async(e, hotSpotIdAsParam) => {
        try {
            if(e)
                e.stopPropagation();
            
            let hotSpotId = hotSpotIdAsParam ? hotSpotIdAsParam.replace('_delete','') : e.target.id.replace('_delete','');

            if(hotSpotId){
                // remove this hotspot from map and all the images

                if( !this.props.hotSpotMapObj || !this.props.hotSpotMapObj.size){
                    alertify.error('Error deleting hotspot. Please reload the page and try again');
                    throw new Error('HotSpotMapObject in store either empty or not defined at all, still hotspot is available for deletion');
                }

                let newHotSpotMapObj = new Map(this.props.hotSpotMapObj);

                let mapKeys = [...newHotSpotMapObj.keys()];

                mapKeys.forEach((key, index)=>{
       
                    let imageId = key;
                    // remove the child element
                    let parentRef = document.getElementById(imageId);
                    
                    // logic here is to hide the element, and on render, the image will be deleted
                    for(let i=1; i< parentRef.children.length; i++){
                        if(parentRef.children[i].id===hotSpotId){
                            parentRef.children[i].style.display = 'none';
                            break;
                        }
                    }

                    this.props.deleteHotspot(hotSpotId, parentRef.id);
                });


                // if currentHotSpotId and currentHotSpotObjId is same as above hotspot id, empty them and reset desc and url as well
                if( this.state.hotSpotObj.size <1 || this.props.hotSpotId === hotSpotId) {
                    this.props.updateCurrentHotSpotId('');
                }
                if( this.state.hotSpotObj.size <1 || this.props.currentHotSpotObj.hotSpotId === hotSpotId ) {
                    this.props.updateCurrentHotSpotObj({});
                }

                // delete image from cloud and sync obj
                let fileName = null;
                let titleDescURL = null;

                if(this.props.syncHotSpotTitleDescURL.has(hotSpotId)){
                    titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotId);
                    // empty sync obj as well as desc and all
                    const newSyncHotSpotTitleDescURL = new Map(this.props.syncHotSpotTitleDescURL);
                    newSyncHotSpotTitleDescURL.delete(hotSpotId);
                    this.props.updateWholeSyncHotSpotTitleDescURL(newSyncHotSpotTitleDescURL);
                }

                if(titleDescURL && titleDescURL.closeUpURL){
                    fileName = titleDescURL.closeUpURL.split('/');
                    fileName = fileName[fileName.length-1];
                    await this.handleImageDeletionFromCLoud(fileName);
                }
                
                // remove li element as well
                let newHotspotObj = new Map(this.state.hotSpotObj);
                newHotspotObj.delete(hotSpotId);
                this.setState({
                    ...this.state,
                    hotSpotObj: newHotspotObj
                })
                
            }else{
                alertify.error('Unknown error occurred, reload the page and try again');
                throw new Error('Id attribute from delete button missing or empty');
            }
            
        } catch (error) {
            //console.log(error)
        }
    }


    handleImageDeletionFromCLoud = async(fileName)=>{
        try {
            
            if(!fileName) return;

            // check if user logged in, auth_key present in cookies
            const cookie = key=>((new RegExp((key || '=')+'=(.*?); ','gm')).exec(document.cookie+'; ') ||['',null])[1];
            let auth_key = cookie('auth_token')
                           
            if(!auth_key) {
                return;
            };

            this.setState({...this.state, imageDeletionLoading: true});
            const url = `${process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX}/api/v1/hotspot/del-hotspot-focus-shoot-image`;
            const body = {
                'auth_key': auth_key,
                'fileName': fileName
            }
            await centralAPI.handlePostRequest(url, body);
        } catch (error) {
            //console.log(error)
        }

        this.setState({...this.state, imageDeletionLoading: false});
    }

    /**
     * On press of enter, update all hotspots' title with this id under all frames
     * @param {*} e 
     * @returns 
     */
     handleHotSpotAllTitleUpdate2 = (e)=>{

        try {
            //this.resetError();

            //e.stopPropagation();
            let key = e.target.id; // hotSpotId is key
            key = key.replace('listId_','');

            //var code = (e.keyCode ? e.keyCode : e.which);
            // if(code === 13) { 
                //Enter keycode
                // update hotspot
                let hotSpotTitleTrimmed = this.state.hotSpotObj.has(key) ? this.state.hotSpotObj.get(key).hotSpotTitle.trim() : '';
                
                //console.log('hotSpotDescTrimmed',hotSpotDescTrimmed);
                if(hotSpotTitleTrimmed.length<1 ) {
                    alertify.error('Title cannot be empty or just spaces');

                    if(this.state.hotSpotObj.has(key)) {
                        let newMap = this.state.hotSpotObj;
                        let tempHotSpotObj = newMap.get(key);
                        tempHotSpotObj.hotSpotTitle = '';
                        newMap.set(key, tempHotSpotObj);

                        this.setState({
                            ...this.state,
                            hotSpotObj: newMap
                        })
                    }

                    return;
                }

                if(!this.state.hotSpotObj.has(key)) {
                    alertify.error('Unknown error occurred. Reload the page');
                    throw new Error('Key missing from state obj HotSpotObj');
                }
                
                // update hotspot title here
                //let hotSpotId = key;

                let newHotSpotMapObj = new Map(this.props.hotSpotMapObj);

                let mapKeys = [...newHotSpotMapObj.keys()];
                //let hotSpotKeys = [...this.state.hotSpotObj.keys()];
                let hotSpotIdInsideMapObj = e.target.id.replace('listId_','');
                
                const titleToUpdate = this.state.hotSpotObj.get(hotSpotIdInsideMapObj).hotSpotTitle.trim();
                mapKeys.forEach((key, index)=>{
                    // if hotspot id is there, update title for it (meanwhile update desc and url as well)

                    try {
                        if( newHotSpotMapObj.get(key).imageHotSpots &&  newHotSpotMapObj.get(key).imageHotSpots.has(hotSpotIdInsideMapObj) ) {     
                            newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotIdInsideMapObj).hotSpotTitle = titleToUpdate;

                            // update desc , url and closeUpURL
                            
                            if(this.props.syncHotSpotTitleDescURL.has(hotSpotIdInsideMapObj)){
                                let titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotIdInsideMapObj);
                                newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotIdInsideMapObj).hotSpotDesc = titleDescURL.desc ? titleDescURL.desc : '';
                                newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotIdInsideMapObj).hotSpotURL = titleDescURL.url ? titleDescURL.url : '';
                                newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotIdInsideMapObj).hotSpotCloseUpURL = titleDescURL.closeUpURL ? titleDescURL.closeUpURL : '';
                            }
                        }            
                    } catch (error) {
                        throw error;
                    }


                });

                // finally update whole hotSpotMap obj in store
                this.props.updateWholeHotSpotMapObj(newHotSpotMapObj);
                
                // also update this title for all the hotspots to keep a sync

                let titleDescURL = null;

                if(this.props.syncHotSpotTitleDescURL.has(key)){
                    titleDescURL = this.props.syncHotSpotTitleDescURL.get(key);
                    titleDescURL.title = titleToUpdate;
                    this.props.upateSyncHotSpotTitleDescURL(key, titleDescURL);
                }

                if(!titleDescURL) {
                    titleDescURL = {
                        'title': titleToUpdate,
                        'desc': '',
                        'url': '',
                        'closeUpURL': ''
                    }
                    this.props.upateSyncHotSpotTitleDescURL(key, titleDescURL);
                }
                //console.log('newHotSpotMapObj',newHotSpotMapObj);
                alertify.success('Hot Spot title updated. Make sure to Save Changes');

                //this.resetState();
            // }

        } catch (error) {
            //console.log(error);
        }
    }

    handleHotSpotTitleChange = (e)=>{

        try {
            //e.stopPropagation();
            let key = e.target.id;

            // remove 'listId_' from key
            key = key.replace('listId_','');
            let newMap = new Map(this.state.hotSpotObj);
            let tempHotSpotObj = newMap.get(key);
            tempHotSpotObj.hotSpotTitle = e.target.value;
            newMap.set(key, tempHotSpotObj);

            //console.log('tempHotSpotObj',tempHotSpotObj);

            this.setState({
                ...this.state,
                hotSpotObj: newMap
            })

        } catch (error) {
            //console.log(error)
        }
    }


    /**
     * Highlight the selected LI tag
     * @param {*} e 
     */
    handleHotSpotGlow = async(e, hotSpotIdBasedOnHotSpotClick)=>{

        try {
            
            let hotSpotId = e ? e.target.id.replace('_li','') : (hotSpotIdBasedOnHotSpotClick ? hotSpotIdBasedOnHotSpotClick : '');
            
            if(hotSpotId){
                    
                let newHotSpotMapObj = [...this.props.hotSpotMapObj.keys()];

                newHotSpotMapObj.forEach((key,index)=>{

                    let imageId = key;
                    // remove the child element
                    let parentRef = document.getElementById(imageId);

                    // logic here is to highlight the hotspot
                    for(let i=1; i< parentRef.children.length; i++){
                        if(parentRef.children[i].id===hotSpotId){
                            parentRef.children[i].style.border = 'solid 2px #FFD9D0';
                            parentRef.children[i].style.borderRadius = '50%';
                            //parentRef.children[i].classList.add('animate-hotspot')
                            parentRef.children[i].classList.add('animate__animated')
                            parentRef.children[i].classList.add('animate__rubberBand')
                            parentRef.children[i].style.setProperty('--animate-duration', '1s');
                            parentRef.children[i].classList.add('animate__repeat-2')
                        }else{
                            parentRef.children[i].style.border='none';
                            parentRef.children[i].classList.remove('animate__animated')
                            parentRef.children[i].classList.remove('animate__rubberBand')
                            parentRef.children[i].style.removeProperty('--animate-duration');
                            parentRef.children[i].classList.remove('animate__repeat-2')
                        }
                    }
                })


                // logic to make background pinkish for the current li tag
                document.querySelectorAll('.unselectedHotSpotLi').forEach(function(li,index) {
                    // Now do something with li
                    if(hotSpotId+'_li' === li.id){
                        li.style.background = '#FFD7B4';
                    }else{
                        li.style.background = '#ffffff';
                    }
                });

                // update current hotspotid with this one
                if( hotSpotId !== this.props.hotSpotId) await this.props.updateCurrentHotSpotId(hotSpotId);

                // check in any frame, where ever this hotspotobj is present, set it to currentHotSpotObj
                if( this.props.currentHotSpotObj &&  this.props.currentHotSpotObj.hotSpotId !== hotSpotId && this.props.hotSpotMapObj.size) {
                    let newHotSpotMapKeys = [...this.props.hotSpotMapObj.keys()];

                    for(let i=0; i<newHotSpotMapKeys.length; i++){
                        let imgKey = newHotSpotMapKeys[i];
                        let currentHotSpotObj = this.props.hotSpotMapObj.get(imgKey).imageHotSpots ? this.props.hotSpotMapObj.get(imgKey).imageHotSpots.get(hotSpotId) : null;

                        if(currentHotSpotObj){
                            // update store's currentHotSpotObj with this obj
                            let currentHotSpotObjInStore = {
                                ...currentHotSpotObj,
                                coordinates: {
                                    xAxis: 50, // in percent (during run time, convert it to pixel)
                                    yAxis:  50// in percent (during run time, convert it to pixel)
                                }
                            }

                            
                            // update in store
                            this.props.updateCurrentHotSpotObj(currentHotSpotObjInStore);
                            break;
                            //console.log(this.props.currentHotSpotObj.hotSpotDesc, this.props.currentHotSpotObj.hotSpotURL)
                            //this.props.handleDescAndUrlStateChange(this.props.currentHotSpotObj.hotSpotDesc, this.props.currentHotSpotObj.hotSpotURL);

                        }
                        
                    }
                    
                }

                
                
            }else{
                alertify.error('Unknown error occurred, reload the page and try again');
                throw new Error('Id attribute from li tag missing or empty'); 
            }

        } catch (error) {
            //console.log(error);
        }

    }

    /**
     * Logic: click on hotspot, the list under add hotspots should glow
     */
    setLiOnHotSpotClick = (hotSpotId)=>{
        try {
            let hotSpotIdBasedOnHotSpotClick = hotSpotId ? hotSpotId : (this.props.hotSpotId ? this.props.hotSpotId : '') ;
            if(hotSpotIdBasedOnHotSpotClick){
                this.handleHotSpotGlow(null, hotSpotIdBasedOnHotSpotClick);
            }
        } catch (error) {
            //console.log(error);
        }
    }

    /**
     * If all hotspots were removed using 'Remove hotspot from frame' ,remove the li as well
     */
    checkRemovalOfLi = async ()=>{
        try {
            //console.log(this.state.hotSpotObj);
            let hotSpotId = this.props.hotSpotId;

            if(hotSpotId){
                // check if this hotSpotId is present in any image frame
                let newHotSpotMapObjKeys = [...this.props.hotSpotMapObj.keys()];
                let isHotSpotPresent = false;

                const newHotSpotMapObj = this.props.hotSpotMapObj;
                for(let i=0; i<newHotSpotMapObjKeys.length; i++){

                    let imageId = newHotSpotMapObjKeys[i];
                    // remove the child element
                    
                    if(newHotSpotMapObj.get(imageId) && newHotSpotMapObj.get(imageId).imageHotSpots && newHotSpotMapObj.get(imageId).imageHotSpots.has(hotSpotId)){
                        isHotSpotPresent = true;
                        break;
                    }
                    
                }

                if(!isHotSpotPresent){
                    // remove li from screen
                    // remove li element as well
                    let newHotspotObj = new Map(this.state.hotSpotObj);
                    newHotspotObj.delete(hotSpotId);
                    // delete image from cloud and sync obj
                    let fileName = null;
                    let titleDescURL = null;

                    if(this.props.syncHotSpotTitleDescURL.has(hotSpotId)){
                        titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotId);
                        // remove this obj from sync
                    }

                    if(titleDescURL && titleDescURL.closeUpURL){
                        fileName = titleDescURL.closeUpURL.split('/');
                        fileName = fileName[fileName.length-1];
                        await this.handleImageDeletionFromCLoud(fileName);
                    }
                    
                    this.setState({
                        ...this.state,
                        hotSpotObj: newHotspotObj
                    });

                    // if currentHotSpotId and currentHotSpotObjId is same as above hotspot id, empty them and reset desc and url as well
                    if( this.state.hotSpotObj.size <1 || this.props.hotSpotId === hotSpotId) {
                        this.props.updateCurrentHotSpotId('');
                    }
                    if( this.state.hotSpotObj.size <1 || this.props.currentHotSpotObj.hotSpotId === hotSpotId ) {
                        this.props.updateCurrentHotSpotObj({});
                    }

                    // empty sync obj as well as desc and all
                    if(this.props.syncHotSpotTitleDescURL.has(hotSpotId)){
                        const newSyncHotSpotTitleDescURL = new Map(this.props.syncHotSpotTitleDescURL);
                        newSyncHotSpotTitleDescURL.delete(hotSpotId);
                        this.props.updateWholeSyncHotSpotTitleDescURL(newSyncHotSpotTitleDescURL);
                    }
                }
            }
        } catch (error) {
            //console.log(error);
        }
    }

    componentDidUpdate(){

        const currentHotSpotId = this.props.hotSpotId;
        this.props.hotSpotDescRefs.desc.current.value = this.props.syncHotSpotTitleDescURL && this.props.syncHotSpotTitleDescURL.has(currentHotSpotId) ? this.props.syncHotSpotTitleDescURL.get(currentHotSpotId).desc : '';
        this.props.hotSpotDescRefs.url.current.value = this.props.syncHotSpotTitleDescURL && this.props.syncHotSpotTitleDescURL.has(currentHotSpotId) ? this.props.syncHotSpotTitleDescURL.get(currentHotSpotId).url : '';;

        // code to set li based on hotspot click
        this.setLiOnHotSpotClick();
    }

    handleLiHotspotIconChange = (e,typeOfHotspot,hotspotObjKey)=>{
        try {
            e.stopPropagation();
            if(!typeOfHotspot || !hotspotObjKey) return;

            // get the state hotSpotObj and update the icon src
    
            if(this.state.hotSpotObj && this.state.hotSpotObj.size && this.state.hotSpotObj.has(hotspotObjKey)){
    
                this.setLiOnHotSpotClick(hotspotObjKey);

                let newMap = new Map(this.state.hotSpotObj);
                let tempHotSpotObj = newMap.get(hotspotObjKey);
                tempHotSpotObj.hotSpotIconSrc = typeOfHotspot.imgSrc;
                newMap.set(hotspotObjKey, tempHotSpotObj);
    
                this.setState({
                    ...this.state,
                    hotSpotObj: newMap
                });

                // change icon for all the hotSpots in all the images

                let newHotSpotMapObj = new Map(this.props.hotSpotMapObj);

                let mapKeys = [...newHotSpotMapObj.keys()];
                //let hotSpotKeys = [...this.state.hotSpotObj.keys()];

      
                // console.log({
                //     'e.arge.id':e.target.id,
                //     'mapKeys': mapKeys,
                //     'hotSpotKeys': hotSpotKeys
                // })

                const iconSrcToUpdate = typeOfHotspot.imgSrc;
                mapKeys.forEach((key, index)=>{
                    // if hotspot id is there, update title for it

                    try {
                        if( newHotSpotMapObj.get(key).imageHotSpots &&  newHotSpotMapObj.get(key).imageHotSpots.has(hotspotObjKey) ) {     
                            newHotSpotMapObj.get(key).imageHotSpots.get(hotspotObjKey).hotSpotIconSrc = iconSrcToUpdate;
                        }            
                    } catch (error) {
                        throw error;
                    }
                });

                // finally update whole hotSpotMap obj in store
                this.props.updateWholeHotSpotMapObj(newHotSpotMapObj);
                //console.log(this.state.hotSpotObj);
            }
        } catch (error) {
            //console.log(error);
        }

    }


    /**
     * Logic to display warning popup
     * @param {*} e 
     */
    displayDeleteWarningPopUp = (e)=>{
        try {
            this.setState({
                ...this.state,
                showDelete : {
                    showDeleteWarningPopUp: true,
                    hotSpotIdToDelete: e.target.id,
                    hotSpotTitleToDelete: this.state.hotSpotObj.get(e.target.id.replace('_delete','')).hotSpotTitle
                }
            });

        } catch (error) {
            //console.log(error);
        }
    }

    /**
     * Logic to handle all hot spot deletion
     * @param {*} choice 
     */
    handleHotSpotLiDeleteChoice = async (choice)=>{
        try {

            if(choice && this.state.showDelete.hotSpotIdToDelete){
                await this.handleAllHotSpotDeletion(null, this.state.showDelete.hotSpotIdToDelete);
            }

            if(choice && !this.state.showDelete.hotSpotIdToDelete) {
                alertify.error('Unknown Error Occurred while trying to delete');
                throw Error('this.state.showDelete.hotSpotIdToDelete came out as null or undefined')
            }

            this.setState({
                ...this.state,
                showDelete : {
                    showDeleteWarningPopUp: false,
                    hotSpotIdToDelete: '',
                    hotSpotTitleToDelete: ''
                }
            });
            
        } catch (error) {
            //console.log(error);
        }
    }


    handleLiHighLight = (e)=>{
        try {
            e.stopPropagation();
            let hotSpotId = e.target.id ? e.target.id.replace('listId_','') : '';

            if(!hotSpotId) return;

            this.setLiOnHotSpotClick(hotSpotId);
            //hotSpotId
        } catch (error) {
            //console.log(error)
        }
    }

    render() {
        return (
            <div className={['col-md-12',Styles['hotspot-plus']].join(' ')}>
                <ul className={[Styles['hotspot-plus-ul']]}>
                    <li>
                    <div className="dropdown">
                        <span className="btn dropdown-toggle" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" 
                            aria-expanded="false" 
                            ref={this.typeOfHotspotCurrentRef}
                        >
                            <img src={typeOfHotspot[0].imgSrc} alt=""/>
                        </span> 
                        Add hotspots <button onClick={ this.handleCreateHotspot } className={[Styles['add-hotspot-btn']]}>+</button>
                        <ul className={[Styles['dropdown-menu'],'dropdown-menu'].join(' ')} aria-labelledby="dropdownMenuLink" >
                            {
                                typeOfHotspot.length ? typeOfHotspot.map(ele=>{
                                    return (
                                        <li onClick={(e)=>this.handleTypeOfHotspot(e, ele)} key={`${ele.type}_li_items`}>
                                            <span className={[Styles['dropdown-item'],'dropdown-item'].join(' ')} >
                                                <img src={ele.imgSrc} alt=""/>
                                            </span>
                                        </li>
                                    )
                                }) : null
                            }
                                
                        </ul>
                    </div>
                    </li>
                </ul>
                
                <>                
                {/* {
                    this.state.error.show  ? <AtomicComponent.AtomAlertify type={this.state.error.type} msg={this.state.error.msg}/> : <></>
                }  */}
                {/* <ul className={[Styles['list-hotspots']]}> */}
                    
                    {
                        this.state.hotSpotObj.size ? (
                            <ul className={[Styles['list-hotspots']]}>
                                
                                    {
                                        [...this.state.hotSpotObj.keys()].map(hotspotObjKey=>{
                                            return (
                                                <li key={hotspotObjKey+"_li"} onClick={this.handleHotSpotGlow} id={hotspotObjKey+"_li"} className={[Styles['list-hotspots'],'unselectedHotSpotLi'].join(' ')}>
                                                    <div onClick={(e)=>e.stopPropagation()} className={[Styles['listhotSpotContainer']].join(' ')}>

                                                        <div  className={[Styles['dropdown']].join(' ')} style={{background: 'white'}}>
                                                            <span className="btn dropdown-toggle" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" 
                                                                aria-expanded="false" 
                                                            >
                                                                <img 
                                                                    src={this.state.hotSpotObj.get(`${hotspotObjKey}`).hotSpotIconSrc} 
                                                                    alt={this.state.hotSpotObj.get(`${hotspotObjKey}`).hotSpotTitle}
                                                                    style={{width:'auto', height:'auto', padding:'0px'}}
                                                                    onClick={(e)=>e.stopPropagation()}
                                                                />  
                                                            </span> 
                                                            <ul className={[Styles['dropdown-menu'],'dropdown-menu'].join(' ')} aria-labelledby="dropdownMenuLink" style={{cursor:'pointer'}}>
                                                                    {
                                                                        typeOfHotspot.length ? typeOfHotspot.map(ele=>{
                                                                            return (
                                                                                <li onClick={(e)=>this.handleLiHotspotIconChange(e, ele, hotspotObjKey)} key={`${ele.type}_li_items_choose`}>
                                                                                    <span className={[Styles['dropdown-item'],'dropdown-item'].join(' ')} >
                                                                                        <img src={ele.imgSrc} alt=""/>
                                                                                    </span>
                                                                                </li>
                                                                            )
                                                                        }) : null
                                                                    }
                                                            </ul>
                                                        </div>

                                                        <input
                                                            value={ this.state.hotSpotObj.has(`${hotspotObjKey}`) ? this.state.hotSpotObj.get(`${hotspotObjKey}`).hotSpotTitle:''}
                                                            //onKeyDown={this.handleHotSpotAllTitleUpdate}
                                                            onBlur={this.handleHotSpotAllTitleUpdate2}
                                                            onChange={this.handleHotSpotTitleChange}
                                                            onClick={this.handleLiHighLight}
                                                            id={'listId_'+hotspotObjKey}
                                                            placeholder='HotSpot Title*'
                                                            style={{border: '0px', outline:'none', width: '100%'}}
                                                            type="text"
                                                        />
                                                    </div>

                                                    <button onClick={(e)=>e.stopPropagation()} className={[Styles['hotspot-del-btn']]}>
                                                        <i 
                                                            className="fa fa-trash-o" 
                                                            aria-hidden="true" 
                                                            onClick={this.displayDeleteWarningPopUp} 
                                                            id={hotspotObjKey+'_delete'}>
                                                        </i>
                                                    </button>
                                                </li>
                                            )
                                        })  
                                    }  
                                                                                    
                            </ul>                 
                        ):(<></>)
                    }

                {/* </ul> */}
                </>

                    {
                        this.state.showDelete.showDeleteWarningPopUp ? (
                            <HotSpotDeleteModal 
                                showDelete={this.state.showDelete} 
                                handleHotSpotLiDeleteChoice={this.handleHotSpotLiDeleteChoice}
                            />
                        ):(null)
                    }

                    {
                        this.state.infoToast.show ? (
                            <Toast 
                                onClose={() => this.setState({...this.state,infoToast:{show:false}})} 
                                show={this.state.infoToast.show} delay={5000} autohide
                                className={[Styles['custom-toast']]}
                            >
                                <Toast.Header>
                                    <strong className="me-auto">New '{this.state.typeOfHotspot.type ? this.state.typeOfHotspot.type : typeOfHotspot[0].type}' HotSpot Added</strong>
                                </Toast.Header>
                                <Toast.Body>Woohoo, you just added a new hotspot. Click anywhere on the image to move the hotspot to that position or simply drag and drop!</Toast.Body>
                            </Toast>
                        ):(null)
                    }

                {
                    this.state.imageDeletionLoading ? (<HotSpotChildComponentLoading />) : null
                }
                    
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps)=>{
    //console.log({'state.hotspotReducer.hotSpotId':state.hotspotReducer.hotSpotId,'state.hotspotReducer.currentImageRefObj':state.hotspotReducer.currentImageRefObj})
    return{
        hotSpotMapObj : state.hotspotReducer.hotSpotMapObj,
        hotSpotCount : state.hotspotReducer.hotSpotCount,
        currentImgObj : state.hotspotReducer.currentImageObj,
        currentImageRef : state.hotspotReducer.currentImageRefObj,
        hotSpotId: state.hotspotReducer.hotSpotId,
        currentHotSpotObj: state.hotspotReducer.currentHotSpotObj,
        syncHotSpotTitleDescURL : state.hotspotReducer.syncHotSpotTitleDescURL
    }
}

const mapDispatchToProps = (dispatch)=>{
    return{
        updateHotspot : (updatedHotSpot, imageId) => dispatch(updateHotspot(updatedHotSpot, imageId)),
        addHotspot: (hotSpotJSON, imageId)=>dispatch(addHotspot(hotSpotJSON, imageId)),
        deleteHotspot : (oldHotSpotId, imageId) => dispatch(deleteHotspot(oldHotSpotId, imageId)),
        updateCurrentHotSpotId: (hotSpotId)=>dispatch(updateCurrentHotSpotId(hotSpotId)),
        updateCurrentHotSpotObj : (hotSpotObj) => dispatch(updateCurrentHotSpotObj(hotSpotObj)),
        updateWholeHotSpotMapObj: (hotSpotMapObj) => dispatch(updateWholeHotSpotMapObj(hotSpotMapObj)),
        upateSyncHotSpotTitleDescURL : (hotSpotId, titleDescURL) => dispatch(upateSyncHotSpotTitleDescURL(hotSpotId, titleDescURL)),
        updateWholeSyncHotSpotTitleDescURL : (syncHotSpotTitleDescURL) => dispatch(updateWholeSyncHotSpotTitleDescURL(syncHotSpotTitleDescURL)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(HotSpotAddDetails);
